import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class HttpCalIInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('token')?.trim();
        const isPdfRequest = localStorage.getItem('type') === 'pdf';
        let headers = request.headers;

        if (token) {
          headers = headers.set('Authorization', `Bearer ${token}`);
        }

        if (isPdfRequest) {
          headers = headers.set('Accept', 'application/pdf');
        }

        return next.handle(request.clone({ headers }));

    }
}
